export function deepClone (obj) {
  if (obj === null || obj === undefined) {
    return obj
  } else {
    return JSON.parse(JSON.stringify(obj))
  }
}

export function frozenDeepClone (obj) {
  return Object.freeze(deepClone(obj))
}
